import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import React from 'react';
import { productInfoComponents } from '../ContentEditor/ContentEditorComponents';
import { DynamicContentRenderer } from '../ContentEditor/DynamicContentRenderer';
import { theme } from '../Theme';

export const SectionHeading = styled('h2')`
  margin-bottom: 0.25em;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: ${theme.colors.darkgrey};
  letter-spacing: 0.03em;
  ${theme.below.lg} {
    margin-bottom: 10px;
  }
`;

export const ProductSection = styled('section')`
  line-height: 1.5;
  width: 100%;
  padding: 2rem;

  ${theme.below.lg} {
    margin: 20px 0;
    padding: 0 25px;
  }

  ${theme.above.lg} {
    :nth-of-type(odd) {
      width: calc(60% - 24px);
    }
    :nth-of-type(even) {
      width: calc(40% - 24px);
    }
  }

  ul.payment-options-list {
    font-size: 16px;
    font-weight: 600;
  }
`;

const SpecificationsWrapper = styled('ul')`
  li {
    font-size: 14px;
  }
`;

const ProductInfo = ({ productBrandId, specifications, articlenumber }) => {
  //Removes Sizeguide id from specifications
  const filteredSpecifications = specifications?.filter(
    specification =>
      specification.key !== 'size_guide_cat_id' &&
      specification.key !== 'sesong'
  );

  return (
    <>
      {productBrandId && (
        <ProductSection>
          <SectionHeading>{t('Product description')}</SectionHeading>
          <DynamicContentRenderer
            categoryId={productBrandId}
            rendererComponents={productInfoComponents}
          />
        </ProductSection>
      )}
      <ProductSection>
        <SectionHeading>{t('Specifications')}</SectionHeading>
        {specifications && (
          <SpecificationsWrapper>
            {filteredSpecifications.map((spec, index) => (
              <li key={index}>
                {spec?.title}: {spec?.stringValue}
              </li>
            ))}
            <li>VareID: {articlenumber}</li>
          </SpecificationsWrapper>
        )}
      </ProductSection>
    </>
  );
};

export default ProductInfo;
